<template>
<div id="IntegratedModelShare" class="model-share-view">
  <!-- 分享页头部 -->
  <share-header
    :file-name="fileName"
    :file-icon="require('@/assets/file/model.png')"
    @login="showLoginDialog = true"
    @logout="handleLogout"
  />

  <div class="model-view" :class="{'error-bg': shareCodeError}">
    <div v-if="shareCodeError" class="error-box">
      <img src="@/assets/img/warning.png" class="warning-img" alt="">
      <span class="warning-text">当前轻量化模型的分享链接已失效，请联系分享人</span>
    </div>
    <bimface
      v-else
      :view-token="shareFileInfo.viewToken"
      :file-id="shareFileInfo.id"
      :share-code="shareCode"
      from="SHARE"
      file-type="INTEGRATED_MODEL"
      height="100%"
      width="100%"
      @require-login="showLoginDialog = true"
    />
  </div>

  <!-- 登录弹框 -->
  <share-login-dialog
    :visible.sync="showLoginDialog"
    @login-success="handleLoginSuccess"
  />
</div>
</template>

<script>
import Config from '@/config'
import Bimface from '@/components/common/Bimface.vue'
import ShareHeader from '@/components/common/ShareHeader.vue'
import ShareLoginDialog from '@/components/common/ShareLoginDialog.vue'

export default {
  name: 'IntegratedModelShare',
  components: { Bimface, ShareHeader, ShareLoginDialog },
  data() {
    return {
      shareCode: this.$route.params.shareCode,
      shareFileInfo: {},
      // 分享码是否失效
      shareCodeError: false,
      // 登录弹框显示状态
      showLoginDialog: false,
    }
  },
  created() {
    // 获取viewToken
    if (this.shareCode) {
      // 获取分享接口的信息
      this.$api.file.integratedModelShareInfo(this.shareCode).then((data) => {
        this.shareCodeError = false
        this.shareFileInfo = data || {}
      }).catch(() => {
        this.shareCodeError = true
      }).finally(() => {
        this.$tracks({
          event: 'viewIntegratedModel3DURL',
          params: {
            g_c_integrated_model_id: this.shareFileInfo.id,
          }
        })
      })
    }
  },
  computed: {
    fileName() {
      return this.shareFileInfo.name || ''
    },
  },
  watch: {
    shareFileInfo() {
      document.title = this.shareFileInfo.name || Config.projectName
    }
  },
  methods: {
    handleLoginSuccess() {
      // 登录成功后刷新页面数据
      this.$message.success('登录成功')
    },
    handleLogout() {
      // 退出登录后的处理
      this.showLoginDialog = false
    }
  },
}
</script>

<style lang="less" scoped>
.model-share-view{
  height: 100%;
}
.model-view{
  height: calc(100vh - 40px);
  &.error-bg{
    background: url("~@/assets/img/login-bg.png") no-repeat center center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.error-box {
  width: 600px;
  height: 500px;
  background: @color-fill-white;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .warning-text {
    font-size: 16px;
    line-height: 32px;
    color: @text-tag-gery;
  }
}
</style>
